export default __webpack_public_path__ + "static/img-data-prep-preview--mobile-21cb0da3830be5ff73fc5add32ce3ca0.png";